import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeSuperSplashLiveSecondaryContentItemContent$key } from "~/queries/__generated__/homeSuperSplashLiveSecondaryContentItemContent.graphql";

import { ActionBar, Container, Content, Headline, StyledEntityLink } from "./styles";

export type Props = {
  reference: homeSuperSplashLiveSecondaryContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeSuperSplashLiveSecondary = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeSuperSplashLiveSecondaryContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <Content>
          <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
            <Headline>
              {provider.headline({ preferSocialHeadline: true, skipHighlight: true })}
            </Headline>
          </StyledEntityLink>
          <ActionBar>
            {provider.actionBar({
              isBookmarkVisible: false,
            })}
          </ActionBar>
        </Content>
      </Container>
    );
  },
);

ContentItemHomeSuperSplashLiveSecondary.displayName = "ContentItemHomeSuperSplashLiveSecondary";
